import { useState } from 'react';

function Rearrangeable(props) {
  const { draggable, handleDragOver, handleDragEnd, handleDragStart } = props;
  const [active, setActive] = useState(false);

  const handleOnDragOver = (event) => handleDragOver && handleDragOver(event);
  const handleOnDragEnd = (event) => {
    setActive(false);
    handleDragEnd && handleDragEnd(event);
  };
  const handleOnDragStart = (event) => {
    setActive(true);
    handleDragStart && handleDragStart(event);
  };

  return (
    <div
      className={`rearrangeable ${active ? 'rearrangeable__active' : ''}`}
      onDragOver={(event) => handleOnDragOver(event)}
    >
      <div
        className="rearrangeable__inner"
        draggable={draggable}
        onDragEnd={(event) => handleOnDragEnd(event)}
        onDragStart={(event) => handleOnDragStart(event)}
      >
        {props.children}
      </div>
    </div>
  );
}

export default Rearrangeable;
